"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrayDifference = exports.validatePasswordFormat = exports.convertEnumToObject = exports.validateEmail = void 0;
const validateEmail = (email) => {
    return Boolean(String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/));
};
exports.validateEmail = validateEmail;
const convertEnumToObject = (enumObject) => {
    const convertedObj = {};
    for (const key in enumObject) {
        if (typeof enumObject[key] !== 'function') {
            convertedObj[key] = enumObject[key];
        }
    }
    return convertedObj;
};
exports.convertEnumToObject = convertEnumToObject;
const validatePasswordFormat = (password) => {
    // One upper character, one lower character, one number, one special character and at least 8 characters required for a valid password.
    return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!#$%&*?@^-]).{8,}$/.test(password);
};
exports.validatePasswordFormat = validatePasswordFormat;
/**
 * <p>getArrayDifference computes the difference between 2 arrays of type T and returns the old entries and new entries</p>
 *
 *  @param {T[]} originalEntries - the original array that was modified (eg: DB entity id or any column)
 *  @param {T[]} modifiedEntries - the array resulting from adding/removing entries in originalEntries array
 *  @returns {[T[], T[]]} - resulting array where first index has old entries (eg: id's to delete from DB) and second index has new entries (eg: id's that should be added in DB)
 *
 *  @example
 *
 *  let originalEntries = [1, 2, 3, 4, 5];
 *  let modifiedEntries = [1, 4, 10, 2]
 *  let [oldEntries, newEntries] = getArrayDifference(originalEntries, modifiedEntries)
 *  // oldEntries => [3, 5]
 *  // newEntries => [10]
 *
 * */
const getArrayDifference = (originalEntries, modifiedEntries) => {
    const oldEntries = originalEntries.filter((entry) => !modifiedEntries.includes(entry));
    const newEntries = modifiedEntries.filter((entry) => !originalEntries.includes(entry));
    return [oldEntries, newEntries];
};
exports.getArrayDifference = getArrayDifference;
